import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import withCollegeService from '../withCollegeService';
import Label from '../../../../components/Label';
import Dropdown from '../../../../components/Dropdown';

import '../styles.css';

export const Level = ({ onChange, initialValue }) => (
  <Dropdown
    placeholder="level"
    fluid
    selection
    options={initialValue.options}
    data-cy="premium-Hem-School-Type-Level-DropDown"
    value={initialValue.value}
    onChange={(e, { value }) => {
      onChange(e, { value });
    }}
  />
);
Level.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

const LevelComponent = withCollegeService(Level, 'overview.schoolType.level', null, {
  value: 'field_he_level',
});

export const Control = ({ onChange, initialValue }) => (
  <Dropdown
    placeholder="control"
    fluid
    selection
    options={initialValue.options}
    data-cy="premium-Hem-School-Type-Control-DropDown"
    value={initialValue.value}
    onChange={(e, { value }) => {
      onChange(e, { value });
    }}
  />
);
Control.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

const ControlComponent = withCollegeService(Control, 'overview.schoolType.control', null, {
  value: 'field_he_control_id',
});

const SchoolType = () => (
  <div>
    <div>
      <Label styleName="menu-field-label">
        <FormattedMessage {...messages.level} />
      </Label>
      <LevelComponent />
    </div>
    <div>
      <Label styleName="menu-field-label">
        <FormattedMessage {...messages.control} />
      </Label>
      <ControlComponent />
    </div>
  </div>
);

export default SchoolType;
